import { get } from 'app/utils/axios/kheti'
import { Node } from 'app/models/RequestFlow'

const fetchStateNodes = async (stateId: number) => {
  try {
    if (!stateId) return []
    return await get<Node[]>(`/common/v1/state/${stateId}/nodes`)
  } catch (e) {
    console.log('Error fetching state nodes:', e)
    return []
  }
}

export default fetchStateNodes
